import * as Reflux from "reflux";
export const CSVUploadActions = {
	showModal: Reflux.createAction(["showModal"]),
	clear: Reflux.createAction(["clear"]),
	clearErroneous: Reflux.createAction(["clearErroneous"]),
	addToCart: Reflux.createAction(["addToCart"]),
	deleteItem: Reflux.createAction(["deleteItem"]),
	setComment: Reflux.createAction(["setComment"]),
	setQuantity: Reflux.createAction(["setQuantity"]),
	uploadFile: Reflux.createAction(["uploadFile"]),
	pasteCSV: Reflux.createAction(["pasteCSV"]),
};
